
import React, { useCallback, useEffect, useState } from 'react';
import {
  useNavigate,
  useLocation
} from 'react-router-dom';

import styles from '../styles/TopMenu.module.css';
import Dropdown from 'react-bootstrap/Dropdown';

import DropdownButton from 'react-bootstrap/DropdownButton';

const TopMenu = ({ username, darkMode, setDarkMode, worker, setLoggedIn }) => {

  const location = useLocation();

  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState();
  const [workerType, setWorkerType] = useState();
  
  useEffect(() => {
    fetch(`/get_batch2/${username}`)
    //fetch(`/get_batch`)
      .then((response) => response.json())
      .then((data) => {
        var userBatch = -99
        for ( let i = 0; i < data.length; i ++)
        { 
          if (( data[i].title.toLowerCase() === username.toLowerCase() ) || ( data[i].title.toLowerCase() === document.getElementById('SelectedBatch').innerHTML.toLowerCase() ))
            { userBatch = i } 
        }
        if ( userBatch >= 0 )
          { 
            setBatches([data[userBatch]]) 
            setSelectedBatch(username)
          }
          else { setBatches(data) }
            
          ;
      });
      
  },[username]); // << This means that the effect will only update when username is updated. 
  // If this [username] is not there, this mysql call is made every screen rendering.
  // That is bad since it makes the computer overheat

  const navigate = useNavigate();
  const nav = useCallback((path) => {
    navigate(path, { replace: true });
  }, [navigate]);

  // The following decides which display page to present 
  //console.log(worker)
  var whatToDisplay = ''
  if ( worker.workerType === "PersonalMultiple" ) 
  { whatToDisplay = "/overview" }
  else { whatToDisplay = "/profile" }
  
  
  return (
    <div className={styles.container}>
      <div className={styles.logo} onClick={() => nav("/")}>
        <div />
        <span>NCM Lab</span>
        
        <label style={{ marginLeft: '10px'}}> Batch:  
            <select id="BatchSelect" style={{ marginLeft: '10px'}}
                onChange={(e) => {
                  setSelectedBatch(e.target.value);
                }} 
              >
              {batches.map((s, i) => {
                return <option
                  key={i}
                  value={s.title}>
                  {s.title}
                </option>
              })}
            </select>     
            </label>
            <b id='SelectedBatch' style={{ marginLeft: '10px'}}>{selectedBatch}</b>
      </div>
      <div className={styles.nav}>
        
        

        <div className={`${location.pathname === "/admin" ? styles.selected : ""}`}
          onClick={() => nav("/admin")}>
          <div className={`${styles.navIcon} ${username === "admin" ? styles.users : styles.link}`} />
          <a href="#!">{"Links"}</a>

        </div>


        <div>
          <DropdownButton id="dropdown-basic-button" title="Options" variant="light">
            <Dropdown.Item onClick={() => nav("/activity")}>Activity</Dropdown.Item>
            <Dropdown.Item onClick={() => nav("/summary")}>Overview</Dropdown.Item>
            <Dropdown.Item onClick={() => setDarkMode(!darkMode)}><div className={`${styles.navIcon} ${darkMode ? styles.sun : styles.moon}`} /></Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={() => {
              document.cookie = "loggedIn=false";
              setLoggedIn(false);
              nav("/")}}>Logout</Dropdown.Item>
          </DropdownButton>
        </div>
      </div>
    </div>
  );
}
export default TopMenu;